import React, { HTMLAttributes } from 'react';

import { AccordionItem } from '@uncinc/uncinc-react-kitchen-sink';

import useClasses from '../../../hooks/useClasses';
import { ImmutableGenericNodeEntity } from '..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeQuestionFaq: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('NodeQuestionFaq');

  const question = entity.getIn(['title', 0, 'value']);
  const answer: string = String(entity.getIn(['field_answer', 0, 'processed']));

  return (
    <div className={joinClasses(buildClass(), className)}>
      <AccordionItem
        title={question}
        content={answer}
        iconClassName="icon-chevron icon-variant-2"
      />
    </div>
  );
};

export default NodeQuestionFaq;
